import cx from "classnames"
import * as React from "react"
import * as styles from "./styles.module.scss"
import TileBorderMedium from "../TileBorderMedium"

const OurThinking: React.FC = () => {
  return (
    <section className={styles.learnMore}>
      <div className={styles.pagePadding}>
        <div className={styles.header}>
          <h3 className={styles.heading}>Our thinking</h3>
        </div>
        <div className={styles.feed}>
          <ul className={styles.grid}>
            <li
              className={cx({
                [styles.item]: true,
                [styles.medium]: true,
              })}
            >
              <TileBorderMedium
                heading="Should you opt for a no‑cost mortgage?"
                ctaPrimary="Try our interactive tool"
                link="/content/no-cost-mortgage/"
              />
            </li>
            <li
              className={cx({
                [styles.item]: true,
                [styles.medium]: true,
              })}
            >
              <TileBorderMedium
                heading="5 reasons why paying loan officer commission is bulls#!t"
                ctaPrimary="Learn about the Better alternative"
                link="/content/5-reasons-why-loan-officer-commission-is-bulls-t/"
              />
            </li>
          </ul>
        </div>
      </div>
    </section>
  )
}

export default OurThinking
